import { Component, OnInit } from '@angular/core';
import { Message } from '../../../models/centre/message.model';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Page } from '../../../models/list/page.model';
import { NewsMemoDetailsPopUpComponent } from './news-memo-detail.popup.component';
import { NewsService } from './new.service';
import { AppConstants } from '../../../shared/constants/constants';
import { WorldTravelNewModel } from '../../../models/centre/manage-memo.model';
import { WorldTravelPopUpComponent } from './world-travel-detail.popup.component';
import { HttpRequest } from 'selenium-webdriver/http';
import { WorldTravelNews } from '../../../models/centre/news.models';
@Component({
    selector: 'app-news-memo',
    templateUrl: 'news-memo.component.html',
    providers: [NewsService]
})

export class NewsMemoComponent implements OnInit {
    constructor(private router: Router,
        public baseService: BaseService,
        public dialogService: DialogService,
        public utility: Utility,
        public newServices: NewsService) { }
    pageMemo = new Page();
    pageClinicNews = new Page();
    pageWorldTravel = new Page();
    memoLoading = false;
    clinicNewsLoading = false;
    worldTravelLoading = false;
    throttle = 300;
    scrollDistance = 1;
    public appConstants = AppConstants;
    public messages = [];
    public isConfirm;
    public messagesGroup = [];
    public messagesWorldTravel = new Array<WorldTravelNews>();
    public messageArr = [];
    selectedMessage: Message;
    public firstLoad = false;
    onSelect(message: Message): void {
        this.selectedMessage = message;
    }

    ngOnInit() {
        this.pageClinicNews.size = this.pageMemo.size = this.pageWorldTravel.size = 30;
        this.pageClinicNews.pageNumber = this.pageMemo.pageNumber = this.pageWorldTravel.pageNumber = 0;
        this.getClinicNewList(this.pageClinicNews);
        this.getMemoList(this.pageMemo);
        this.getWorldTravelNewList();
        this.firstLoad = true;
    }

    onScrollDown(group: number, currentPage: number) {
        switch (group) {
            case 1: {
                if (this.clinicNewsLoading) {
                    return;
                }
                this.clinicNewsLoading = true;
                this.pageClinicNews.pageNumber = currentPage + 1;
                this.getClinicNewList(this.pageClinicNews);
                break;
            }
            case 2: {
                if (this.memoLoading) {
                    return;
                }
                this.memoLoading = true;
                this.pageMemo.pageNumber = currentPage + 1;
                this.getMemoList(this.pageMemo);
                break;
            }
            case 3: {
                // if (this.worldTravelLoading) {
                //     return;
                // }
                // this.worldTravelLoading = true;
                // this.pageWorldTravel.pageNumber = currentPage + 1;
                // this.getWorldTravelNewList();
                break;
            }
            default:
                break;
        }
    }

    getWorldTravelNewList() {
        this.newServices.getAllWorldTravelNew(callback => {
            if (callback) {
                this.messagesWorldTravel = callback;
            }
        });
    }

    getMemoList(pageInfo) {
        let param = {
            pageSize: pageInfo.size,
            currentPage: pageInfo.pageNumber + 1,
        };
        this.newServices.getAllMemo(param).subscribe(
            (result) => {
                this.memoLoading = false;
                if (result) {
                    const data = result.json();
                    this.messages = this.messages.concat(data['list']);
                }
            },
            error => { this.memoLoading = false; }
        );
    }

    getClinicNewList(pageInfo) {
        const param = {
            countryId: localStorage.getItem(AppConstants.localStorage.countryId),
            centreId: localStorage.getItem(AppConstants.localStorage.centreId),
            pageSize: pageInfo.size,
            currentPage: pageInfo.pageNumber + 1,
        };

        this.newServices.getAllClinicNew(param).subscribe(
            (result) => {
                this.clinicNewsLoading = false;
                if (result) {
                    const data = result.json();
                    this.messagesGroup = this.messagesGroup.concat(data['list']);
                }
            },
            error => { this.clinicNewsLoading = false; }
        );
    }

    onOpenNewsMemoDetailDialog(message) {
        this.dialogService.openComponentDialog(NewsMemoDetailsPopUpComponent,
            { id: message.id },
            {}).subscribe(
                result => {
                    if (result) {
                        message.isConfirm = result;
                        if(message.isConfirm){
                            message.confirmDate = new Date().toUTCString();                            
                        }                        
                        // this.setPage({ offset: 0 });
                    }
                }
            );
    }

    onOpenWorldTravelDialog(message) {
        this.dialogService.openComponentDialog(WorldTravelPopUpComponent,
            {
                id: message.id,
                news: message
            },
            {}).subscribe(
                result => {
                    if (result) {
                        // this.setPage({ offset: 0 });
                    }
                }
            );
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/news-memo/news-memo.component.ts